/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-container[_ngcontent-%COMP%]{min-height:95%;padding-top:125px}@media (min-width:320px) and (max-width:420px){.main-container[_ngcontent-%COMP%]{padding-top:80px}}@media (min-width:421px) and (max-width:480px){.main-container[_ngcontent-%COMP%]{padding-top:100px}}.parent-container[_ngcontent-%COMP%]{height:100%}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
